import React, { createContext } from 'react';
import { AuthProvider, useAuth } from './AuthContext.jsx';

const UserContext = createContext({ auth: false });

function UserInnerProvider({ children }) {
  const auth = useAuth();
  const value = {
    auth: Boolean(auth.user),
    user: auth.user,
    token: auth.token,
    loading: auth.loading,
    error: auth.error,
    login: auth.login,
    logout: auth.logout,
    sendOtp: auth.sendOtp,
    verifyOtp: auth.verifyOtp,
  };
  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
}

export const UserProvider = ({ children }) => (
  <AuthProvider>
    <UserInnerProvider>{children}</UserInnerProvider>
  </AuthProvider>
);

export default UserContext;
export const UserConsumer = UserContext.Consumer;
